import React from "react";
import Slider from "react-slick";

export const Header = (props) => {
  
  function NextArrow ({ className, style, onClick }) {
    return (
      <div className={className}
     style={{...style, display: 'block', color: '#00d5fb', transform: "scale(2.5)"}} onClick={onClick}
      />
    );
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 788,
        settings: 'unslick'
      },]
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-14 intro-text slider-container">
            <Slider {...settings}>
                  <h1>
                  <div className="col-md-6 center-title-right">
                      {props.data ? props.data.title1 : "Cargando"}
                      <span></span>
                      <p>{props.data ? props.data.paragraph1 : "Cargando"}</p>
                      <video width="320" height="240" controls autoPlay muted>
                        <source src={props.data ? props.data.video1 : "Cargando"} type="video/mp4" />
                       {/* <source src="movie.ogg" type="video/ogg" />*/}
                        Your browser does not support the video tag.
                      </video>
                    </div>
                    <div className="col-md-6">
                    {" "}
                    <img src={props.data ? props.data.image1 : "Cargando"} className="img-responsive" alt="" />{" "}
                    </div>
                    <div className="col-md-12">
                    <div className="row">
                  <a href="#features" className="btn btn-custom1 btn-lg page-scroll">
                  Conocer más
                </a>{" "}
                </div>
                </div>
                </h1>
              <div>
                  <h1>
                    <div className="col-md-6">
                    {" "}
                    <img src={props.data ? props.data.image2 : "Cargando"} className="img-responsive" alt="" />{" "}
                    </div>
                    <div className="col-md-6 center-title-left">
                      {props.data ? props.data.title2 : "Cargando"}
                      <span></span>
                      <p>{props.data ? props.data.paragraph2 : "Cargando"}</p>
                    </div>
                    <div className="col-md-12">
                    <div className="row">
                  <a href="#features" className="btn btn-custom1 btn-lg page-scroll">
                  Conocer más
                </a>{" "}
                </div>
                </div>
                </h1>
              </div>
              <div>
                <h1>
                  <div className="col-md-12">
                    {" "}
                    <img src={props.data ? props.data.image3 : "Cargando"} className="img-responsive" alt="" />{" "}
                    </div>
                    <div className="col-md-12 center-title-left">
                      {props.data ? props.data.title3 : "Cargando"}
                      <span></span>
                      <p>{props.data ? props.data.paragraph3 : "Cargando"}</p>
                    </div>
               <div className="col-md-12">
                    <div className="row">
                  <a href="#features" className="btn btn-custom1 btn-lg page-scroll">
                  Conocer más
                </a>{" "}
                </div>
                </div>
                </h1>
              </div>
              </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};


/*
                <p>{props.data ? props.data.paragraph1 : "Cargando"}</p>
                <a
                  href="#features"
                  className="btn btn-custo1 btn-lg page-scroll"
                >
                  Conocer más
                </a>{" "}


                                <p>{props.data ? props.data.paragraph2 : "Cargando"}</p>
                <a
                  href="#features"
                  className="btn btn-custom1 btn-lg page-scroll"
                >
                  Conocer más
                </a>{" "}
                */